import styled from 'styled-components'

const ContentListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap-16);
`

export { ContentListWrapper }
